@if (choosenLines$ | async; as choosenLines) {
  @if (choosenLines.length) {
    <fieldset>
      @if ({ value: selectedLineInBlade$ | async }; as selectedLineInBlade) {
        <div
          class="selected-results"
          #selectedResultsContainer>
          @for (line of choosenLines; track trackByKey.bind(this, 'routeId')($index, line)) {
            <input
              type="checkbox"
              name="selected-line"
              [id]="line.routeId"
                    [checked]="selectedLineInBlade.value?.routeId === line.routeId 
                        && selectedLineInBlade.value?.firstStopDestinationSign === line.firstStopDestinationSign"/>
              <div class="selected-line" (click)="onClickSelectedLine(line)">
                <div class="line">
                  <div class="route">{{ line.routePublicName }}</div>
                  <div class="text">
                    <span class="caption-bold">{{ line.firstStopDestinationSign }}</span>
                    @if (trafficDeviationStopPlaces$ | async; as stopPlaces) {
                      <div class="stops">
                        @if (!stopPlaces[line.routeId+line.firstStopDestinationSign]?.length) {
                          <span class="caption gray" translate>No stops selected</span>
                        }
                        @if ((stopPlaces[line.routeId+line.firstStopDestinationSign] | selectedStopPlaces)?.length > 2) {
                          <span class="caption"
                            >
                            {{ stopPlaces[line.routeId+line.firstStopDestinationSign][0].placeDescription }} {{ stopPlaces[line.routeId+line.firstStopDestinationSign][0].platformCode }} - {{ stopPlaces[line.routeId+line.firstStopDestinationSign][(stopPlaces[line.routeId+line.firstStopDestinationSign] | selectedStopPlaces).length-1].placeDescription }} {{ stopPlaces[line.routeId+line.firstStopDestinationSign][(stopPlaces[line.routeId+line.firstStopDestinationSign] | selectedStopPlaces).length-1].platformCode }}
                          </span>
                        }
                        @if ((stopPlaces[line.routeId+line.firstStopDestinationSign] | selectedStopPlaces)?.length < 3) {
                          <span class="caption"
                            >
                            @for (stopPlace of stopPlaces[line.routeId+line.firstStopDestinationSign] | selectedStopPlaces; track trackByKey.bind(this, 'placeId')(index, stopPlace); let index = $index) {
                              {{ index ? ', ' : '' }}{{ stopPlace.placeDescription }} {{ stopPlace.platformCode }}
                            }
                          </span>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="close">
                  <button
                    type="button"
                    (click)="onClickRemoveLine(line)"
                    click-stop-propagation>
                    <app-svg-icon [path]="'assets/icons/x-mark.svg'"></app-svg-icon>
                  </button>
                </div>
                @if (line.lineStopSearchLoader) {
                  <places-spinner>
                  </places-spinner>
                }
              </div>
            }
          </div>
        }
      </fieldset>
    }
  }